import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IWifiAnalyzerResults} from '../../../../../services/AngularServices/WifiAnalyzerService';
import {router} from '../../icons';
import {ConnectedNetworkBox} from './ConnectedNetworkBox';
import {OtherNetworkBox} from './OtherNetworkBox';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface MyNetworkTabProps {
    results: IWifiAnalyzerResults;
    translate: ITranslate;
    getDbmColor: (dbm: number | undefined) => string;
}

@observer
export class MyNetworkTab extends TechseeBaseComponent<MyNetworkTabProps> {
    renderInternal() {
        const {results, translate, getDbmColor} = this.props;
        const networksList = results.surroundingNetworks || results.scanAreaResults || [];
        const connection = results.wifiConnectionInfo;

        const otherNetworks = networksList.filter((net) => net?.ssid === connection?.ssid);

        return (
            <div className='tab-box-container'>
                <div className='tab-box-icons-and-description padding-10'>
                    <div className={'icon'}>{router}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.CONNECTED_ACCESS_POINT')} </span>
                </div>

                {connection && (
                    <ConnectedNetworkBox translate={translate} connection={connection} getDbmColor={getDbmColor} />
                )}

                {otherNetworks && otherNetworks.length > 0 && (
                    <div>
                        <div className='tab-box-icons-and-description padding-10'>
                            <div className={'icon'}>{router}</div>
                            <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.OTHER_ACCESS_POINTS')} </span>
                        </div>

                        {otherNetworks.map((device, idx) => (
                            <OtherNetworkBox
                                key={idx}
                                device={device}
                                getDbmColor={getDbmColor}
                                isNetworkTab={false}
                                translate={translate}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}
